/* eslint camelcase: 0 */

import { Publication as Data } from '@/typings/api/Publication'
import { Model, createMessages } from '@/helpers/Model'


export class LkTopicPublicationModel extends Model<Data> {
  public static readonly page_title = createMessages({
    ...Model.page_title,
  });
}
